import type { ActionModel } from '@jet/environment/types/models';

export interface CloseFullScreenPlayerAction extends ActionModel {
    $kind: 'closeFullScreenPlayerAction';
}

export function makeCloseFullScreenPlayerAction(): CloseFullScreenPlayerAction {
    return {
        $kind: 'closeFullScreenPlayerAction',
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}
